export type TrendingItem = {
  rank: number;
  title: string;
  category: string;
  heat: number;
  trend: 'up' | 'down' | 'steady' | 'new';
  articleId?: string;
};

export const trendingList: TrendingItem[] = [
  { rank: 1, title: '《长夜引》片场花絮流出，主创深夜对戏引讨论', category: '影视现场', heat: 9820, trend: 'up', articleId: 'changye-pianchang-huaxu' },
  { rank: 2, title: '音乐节压轴返场三首，万人合唱画面冲上热搜', category: '音乐现场', heat: 9140, trend: 'new', articleId: 'chunshan-yinyuejie-wanchang' },
  { rank: 3, title: '综艺录制路透刷屏，嘉宾临场发挥成最大看点', category: '综艺录制', heat: 8760, trend: 'up', articleId: 'zongyi-luzhao-kandian' },
  { rank: 4, title: '品牌联名上新三小时售罄，粉丝排队话题升温', category: '品牌合作', heat: 8210, trend: 'down', articleId: 'pinpai-lianming-shouqing' },
  { rank: 5, title: '粉丝自发应援登上城市大屏，路人直呼排面', category: '粉丝圈层', heat: 7640, trend: 'steady', articleId: 'fensi-yingyuan-daping' },
  { rank: 6, title: '年度评选入围名单公布，几家欢喜几家讨论', category: '影视现场', heat: 7080, trend: 'up', articleId: 'niandu-pingxuan-rumu' },
  { rank: 7, title: '新专辑首波试听公开，编曲走向引乐评人热议', category: '音乐现场', heat: 6620, trend: 'new', articleId: 'xingzhuan-shiting-gongkai' },
  { rank: 8, title: '剧集收官夜讨论量破表，结局走向意见两极', category: '影视现场', heat: 6310, trend: 'down', articleId: 'juji-shouguan-jieju' },
  { rank: 9, title: '直播连线突发状况，主持人救场被夸高情商', category: '综艺录制', heat: 5740, trend: 'steady', articleId: 'zhibo-lianxian-jiuchang' },
  { rank: 10, title: '幕后纪录片定档，主创采访片段先导释出', category: '影视现场', heat: 5210, trend: 'new' },
  { rank: 11, title: '代言官宣换新物料，视觉风格获好评', category: '品牌合作', heat: 4820, trend: 'up' },
  { rank: 12, title: '巡演加开两站，票务规则同步更新', category: '音乐现场', heat: 4360, trend: 'steady' },
];

export type HotComment = {
  id: string;
  user: string;
  avatarSeed: string;
  content: string;
  likes: number;
  time: string;
};

export const hotComments: HotComment[] = [
  { id: 'c1', user: '柠檬气泡', avatarSeed: 'lemon', content: '每天刷一圈这里就够了，省得几个平台来回切。今天的片场花絮确实值得一看。', likes: 482, time: '32分钟前' },
  { id: 'c2', user: '深夜不睡党', avatarSeed: 'night', content: '返场那三首我真的会哭，现场灯海太有氛围感了，希望明年还有。', likes: 356, time: '1小时前' },
  { id: 'c3', user: '理性吃瓜', avatarSeed: 'calm', content: '还是那句话，花絮和路透都只是片段，看看就好，不用急着下结论。', likes: 291, time: '2小时前' },
  { id: 'c4', user: '追剧到天明', avatarSeed: 'drama', content: '开放式结局我其实能接受，就是铺垫太久，等一个明确交代。', likes: 244, time: '3小时前' },
  { id: 'c5', user: '综艺下饭菜', avatarSeed: 'snack', content: '临场发挥那个片段我看了五遍，剪进正片我肯定买账。', likes: 188, time: '4小时前' },
  { id: 'c6', user: '路过看看', avatarSeed: 'passerby', content: '大屏应援那天刚好路过，真的会停下来拍照，排面这块没得说。', likes: 143, time: '5小时前' },
];

export const faqs = [
  {
    q: '「黑料今日」每天几点更新？',
    a: '榜单在每天上午十点前后完成第一轮更新，晚间视当日讨论量再做一次热度校准。首页与热搜榜页显示的数据均为最近一次更新的结果。',
  },
  {
    q: '站内内容是原创吗？',
    a: '站内文章是对公开网络讨论的整理、归纳与盘点，会标注话题来源方向与讨论时间。我们不做独家爆料，也不提供未经核实的指控性内容。',
  },
  {
    q: '热度值是怎么计算的？',
    a: '热度值综合了话题在多个公开平台的讨论量、转发量、评论量与时间衰减，用来呈现相对的高低排序，不代表任何事实判断。',
  },
  {
    q: '为什么有的热门话题没有收录？',
    a: '出于内容合规与信息核实的考虑，涉及个人隐私、未经证实或存在明显争议风险的话题不会被收录。我们宁愿少一条，也不愿传错一条。',
  },
  {
    q: '可以投稿或者举报内容吗？',
    a: '可以。在「关于我们」页面留下联系邮箱与说明即可，我们会在工作日内查看。如果是内容纠错，请尽量附上可核对的公开来源。',
  },
  {
    q: '站内内容代表什么立场？',
    a: '站内所有内容仅代表网友讨论的聚合视角，不构成对任何人、任何事件的事实认定。请理性阅读，独立判断。',
  },
];